import {Component, Input, OnInit} from '@angular/core';
import {IUserActivity} from "../user-activity.model";

@Component({
    selector: 'db-activities-list',
    templateUrl: './activities-list.component.html',
    styleUrls: ['./activities-list.component.scss'],
    standalone: false
})
export class ActivitiesListComponent implements OnInit {

  @Input() activities: IUserActivity[];
  public currentPage: number = 1;
  public itemsPerPage: number = 30;
  public isMobile: boolean;

  constructor() { }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
  }

}
